import GeneralTab from 'components/desktop/ShoppingCart/Search/tabs/GeneralTab';
import STATUS from 'types/ShoppingCart/Status';

const LiveTab = () => {
	return <GeneralTab status={STATUS.LIVE} />;
};

export default LiveTab;
